import { useTranslation } from 'react-i18next';
import { ReturnItem } from 'returnCenter-api';
import Text from 'components/ui/Text';
import { batchMoveBlocker } from 'utils/batchRowMove';

/** Why a row of a sent batch can no longer move, or that moving it clears its missing mark. */
const BatchMoveBlockerText = ({ item }: { item: ReturnItem }) => {
    const { t } = useTranslation();
    const blocker = batchMoveBlocker(item);

    const text =
        blocker === 'processed'
            ? t(
                  'batchReturn.moveBlockedProcessed',
                  'The receiving company has already made a return slip for this row.',
              )
            : blocker === 'completed'
            ? t('batchReturn.moveBlockedCompleted', 'Batch #{{id}} is completed.', { id: item.batchReturnId })
            : item.batchMissing
            ? t('batchReturn.moveClearsMissing', 'Marked missing by the receiving company. Moving it clears the mark.')
            : null;

    if (!text) return null;

    return (
        <Text fontSize={11} color={blocker ? 'textLight' : 'error'}>
            {text}
        </Text>
    );
};

export default BatchMoveBlockerText;
